type Theme = 'vw' | 'rio';

const themeForHostnames: Record<string, Theme> = {
    'vw-qa.scm-despatch.rio.cloud': 'vw',
    'vw-prod.scm-despatch.rio.cloud': 'vw',
};

export const setTheme = () => {
    const theme = import.meta.env.VITE_THEME_OVERRIDE ?? themeForHostnames[location.hostname] ?? 'rio';
    document.documentElement.setAttribute('data-brand', theme);
};
